//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CodeInputComponent",
  model: {
    prop: "onChange",
    event: "updateVal",
  },
  props: {
    // input输入文字
    onChange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      input: "", // 文本输入框绑定文字
    };
  },
  computed: {
    /**
     * 计算输入长度
     */
    inputLength() {
      return this.input.length;
    },
  },
  watch: {
    input(val) {
      this.$emit("updateVal", val);
    },
    onChange(val) {
      this.input = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/login/send_code/CodeInput.vue